import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Loader2, Sparkles, Eye, Truck, ShieldCheck, ArrowRight } from "lucide-react";

const values = [
  { icon: Eye, title: "Pratinjau Langsung", desc: "Lihat hasil cetak sebelum memesan." },
  { icon: ShieldCheck, title: "Kualitas Terjaga", desc: "Cetak HD, warna tajam, tahan lama." },
  { icon: Truck, title: "Kirim Nasional", desc: "Melayani seluruh Indonesia." },
];

export default function About() {
  const [about, setAbout] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/settings/about").then((r) => setAbout(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="App">
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        {loading || !about ? (
          <div className="flex justify-center py-24"><Loader2 className="w-8 h-8 animate-spin text-[#F0005A]" /></div>
        ) : (
          <>
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#F0005A]/10 text-[#F0005A] text-xs font-semibold mb-6">
                  <Sparkles className="w-3.5 h-3.5" /> Tentang Kami
                </div>
                <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#00133F] leading-tight" data-testid="about-title">{about.title}</h1>
                <div className="mt-6 space-y-4">
                  {about.body.split("\n").filter((l) => l.trim()).map((para, i) => (
                    <p key={i} className="text-slate-600 leading-relaxed">{para}</p>
                  ))}
                </div>
                <Link to="/produk" className="inline-block mt-8">
                  <Button className="rounded-full h-12 px-7 bg-[#F0005A] hover:brightness-110 text-white">
                    Mulai Desain <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </Link>
              </div>
              {about.image_url && (
                <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }}
                  className="rounded-2xl overflow-hidden border border-slate-200 shadow-[0_20px_60px_rgb(10,25,47,0.12)]">
                  <img src={about.image_url} alt="" className="w-full h-[420px] object-cover" />
                </motion.div>
              )}
            </div>

            <div className="grid sm:grid-cols-3 gap-6 mt-16">
              {values.map((v) => (
                <div key={v.title} className="rounded-2xl border border-slate-200 bg-white p-6">
                  <div className="w-11 h-11 rounded-xl bg-[#00133F] flex items-center justify-center mb-4">
                    <v.icon className="w-5 h-5 text-[#F0005A]" />
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-[#00133F]">{v.title}</h3>
                  <p className="text-sm text-slate-500 mt-2">{v.desc}</p>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
